"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _formField = _interopRequireDefault(require("../fields/form-field"));

var _sift = _interopRequireDefault(require("sift"));

var _objectForm = _interopRequireDefault(require("../object-form"));

var ValidatorWhere =
/*#__PURE__*/
function (_ObjectForm) {
  (0, _inherits2.default)(ValidatorWhere, _ObjectForm);

  function ValidatorWhere() {
    (0, _classCallCheck2.default)(this, ValidatorWhere);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf3.default)(ValidatorWhere).apply(this, arguments));
  }

  (0, _createClass2.default)(ValidatorWhere, [{
    key: "validate",
    value: function validate() {
      (0, _get2.default)((0, _getPrototypeOf3.default)(ValidatorWhere.prototype), "validate", this).call(this);

      if (this._valueSet) {
        try {
          // Use sift to validate the where
          (0, _sift.default)(this._valueSet);
        } catch (err) {
          this._errorFromSet = err.message;
          this.set({
            err: true
          });
        }
      }
    }
  }]);
  return ValidatorWhere;
}(_objectForm.default);

var WhereField =
/*#__PURE__*/
function (_FormField) {
  (0, _inherits2.default)(WhereField, _FormField);

  function WhereField() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, WhereField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(WhereField)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_className", 'WhereField');
    return _this;
  }

  (0, _createClass2.default)(WhereField, [{
    key: "_create",
    value: function _create(props) {
      (0, _get2.default)((0, _getPrototypeOf3.default)(WhereField.prototype), "_create", this).call(this, props);

      this._setDefaults(props, {
        form: new ValidatorWhere()
      });
    }
  }]);
  return WhereField;
}(_formField.default);

exports.default = WhereField;